import React from 'react'

import { EditAccountModal } from '../../../shared/components/EditAccountModal'
import { INTERAX_COLORS } from '../../../constants/colors'
import { useTranslation } from '../../../shared/hooks/useIntractionTranslate'

interface ProfileEditAccountModalContainerProps {
  isOpen: boolean
  onClose: () => void
  onSave: () => Promise<void>
  displayName: string
  phoneNumber: string
  onDisplayNameChange: (v: string) => void
  onPhoneNumberChange: (v: string) => void
  error: string
  isSaving: boolean
}

/**
 * Wraps `EditAccountModal` with the project's color tokens and translation keys.
 * State is owned by the page (via `useProfileEditForm`) and passed in.
 */
export const ProfileEditAccountModalContainer: React.FC<ProfileEditAccountModalContainerProps> = ({
  isOpen,
  onClose,
  onSave,
  displayName,
  phoneNumber,
  onDisplayNameChange,
  onPhoneNumberChange,
  error,
  isSaving
}) => {
  const { t } = useTranslation()

  return (
    <EditAccountModal
      isOpen={isOpen}
      onClose={onClose}
      onSave={onSave}
      displayName={displayName}
      phoneNumber={phoneNumber}
      onDisplayNameChange={onDisplayNameChange}
      onPhoneNumberChange={onPhoneNumberChange}
      error={error}
      isUpdating={isSaving}
      colors={{
        textPrimary: INTERAX_COLORS.white,
        textError: INTERAX_COLORS.redError
      }}
      translations={{
        title: t('facilitator.profile.editAccountInformation'),
        displayNameLabel: t('facilitator.profile.displayNameLabel'),
        displayNamePlaceholder: t('facilitator.profile.displayNamePlaceholder'),
        phoneNumberLabel: t('facilitator.profile.phoneNumberLabel'),
        phoneNumberPlaceholder: t('facilitator.profile.phoneNumberPlaceholder'),
        cancel: t('common.cancel'),
        save: t('common.save'),
        loading: t('common.loading')
      }}
    />
  )
}
